// // // // // import { useState, useRef, useEffect } from "react";
// // // // // import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// // // // // import { stripePromise } from "../utils/stripe";
// // // // // import { getPaymentDetails } from "../utils/paymentConfig";
// // // // // import { trackPaymentModalOpened, trackPaymentFailed } from "../utils/transactions";
// // // // // import apiConfig from "../utils/apiConfig";

// // // // // const CARD_STYLE = {
// // // // //   style: {
// // // // //     base: {
// // // // //       fontSize: "15px",
// // // // //       color: "#343A40",
// // // // //       fontFamily: "'Inter', sans-serif",
// // // // //       "::placeholder": { color: "#ADB5BD" },
// // // // //     },
// // // // //     invalid: { color: "#A32D2D" },
// // // // //   },
// // // // // };

// // // // // function CheckoutForm({ onSuccess, onClose, userEmail, userName, planId, userId, serverPlanPrice }) {
// // // // //   const stripe = useStripe();
// // // // //   const elements = useElements();
// // // // //   const [loading, setLoading] = useState(false);
// // // // //   const [error, setError] = useState("");
// // // // //   const isSubmitting = useRef(false);

// // // // //   // ── Price display: server wins over servicesConfig ──
// // // // //   const paymentDetails = getPaymentDetails(planId || "ats_basic");
// // // // //   const priceDisplay   = serverPlanPrice?.priceDisplay || paymentDetails?.priceDisplay || "$1.99";
// // // // //   const productName    = serverPlanPrice?.planName     || paymentDetails?.serviceName  || "ATS Resume Analysis";
// // // // //   const planName       = paymentDetails?.planName      || "Pay Per Use";

// // // // //   async function handlePay(e) {
// // // // //     e.preventDefault();
// // // // //     if (!stripe || !elements) return;
// // // // //     if (isSubmitting.current) return; // ── Block double-click

// // // // //     isSubmitting.current = true;
// // // // //     setError("");
// // // // //     setLoading(true);

// // // // //     try {
// // // // //       // ── Step 1: Create payment intent on server (amount set server-side) ──
// // // // //       const intentRes = await fetch(`${apiConfig.BACKEND_URL}/create-payment-intent`, {
// // // // //         method:  "POST",
// // // // //         headers: { "Content-Type": "application/json" },
// // // // //         body:    JSON.stringify({
// // // // //           planId: planId || "ats_basic",
// // // // //         }),
// // // // //       });

// // // // //       if (!intentRes.ok) {
// // // // //         const { error: serverError } = await intentRes.json();
// // // // //         throw new Error(serverError || "Could not initiate payment.");
// // // // //       }

// // // // //       const { clientSecret } = await intentRes.json();

// // // // //       // ── Step 2: Confirm card payment with Stripe ──
// // // // //       const { error: stripeErr, paymentIntent } = await stripe.confirmCardPayment(
// // // // //         clientSecret,
// // // // //         { payment_method: { card: elements.getElement(CardElement) } }
// // // // //       );

// // // // //       if (stripeErr) {
// // // // //         setError(stripeErr.message);
// // // // //         // Track payment failure
// // // // //         await trackPaymentFailed(userId, planId, stripeErr.message).catch(() => {});
// // // // //         // Notify server to send failure email
// // // // //         fetch(`${apiConfig.BACKEND_URL}/email/payment-failed`, {
// // // // //           method:  "POST",
// // // // //           headers: { "Content-Type": "application/json" },
// // // // //           body:    JSON.stringify({ userEmail, userName, errorMessage: stripeErr.message, amount: priceDisplay, planId }),
// // // // //         }).catch(() => {});
// // // // //         return;
// // // // //       }

// // // // //       if (paymentIntent.status === "succeeded") {
// // // // //         // ── Step 3: Verify payment server-side before saving ──
// // // // //         const verifyRes = await fetch(`${apiConfig.BACKEND_URL}/verify-payment`, {
// // // // //           method:  "POST",
// // // // //           headers: { "Content-Type": "application/json" },
// // // // //           body:    JSON.stringify({ paymentIntentId: paymentIntent.id }),
// // // // //         });

// // // // //         const verifyData = await verifyRes.json();
// // // // //         if (!verifyRes.ok) {
// // // // //           throw new Error(verifyData.error || "Payment verification failed. Contact support.");
// // // // //         }

// // // // //         // ── Step 4: Trigger success email from server (not client) ──
// // // // //         fetch(`${apiConfig.BACKEND_URL}/email/payment-success`, {
// // // // //           method:  "POST",
// // // // //           headers: { "Content-Type": "application/json" },
// // // // //           body:    JSON.stringify({
// // // // //             userEmail,
// // // // //             userName,
// // // // //             transactionId: paymentIntent.id,
// // // // //             amount:        priceDisplay,
// // // // //             planId,
// // // // //           }),
// // // // //         }).catch(() => {}); // fire and forget

// // // // //         // ── Step 5: Hand verified data back to parent ──
// // // // //         // amountPaid is cents from Stripe — the true price charged, frozen at payment time
// // // // //         onSuccess(paymentIntent.id, verifyData.includes || null, {
// // // // //           amountPaid:    verifyData.amountPaid,
// // // // //           amountDisplay: verifyData.amountDisplay,
// // // // //           currency:      verifyData.currency || "usd",
// // // // //           planName:      verifyData.planName || planId,
// // // // //         });
// // // // //       }

// // // // //     } catch (err) {
// // // // //       const msg = err.message || "Payment failed. Please try again.";
// // // // //       setError(msg);
// // // // //       await trackPaymentFailed(userId, planId, msg).catch(() => {});
// // // // //       // Notify server to send failure email
// // // // //       fetch(`${apiConfig.BACKEND_URL}/email/payment-failed`, {
// // // // //         method:  "POST",
// // // // //         headers: { "Content-Type": "application/json" },
// // // // //         body:    JSON.stringify({ userEmail, userName, errorMessage: msg, amount: priceDisplay }),
// // // // //       }).catch(() => {});
// // // // //     } finally {
// // // // //       setLoading(false);
// // // // //       isSubmitting.current = false;
// // // // //     }
// // // // //   }

// // // // //   return (
// // // // //     <form onSubmit={handlePay}>
// // // // //       <div style={{ marginBottom: 20 }}>
// // // // //         <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: "var(--gray-700)", marginBottom: 8 }}>
// // // // //           Card details
// // // // //         </label>
// // // // //         <div style={{ border: "1.5px solid var(--gray-300)", borderRadius: 10, padding: "12px 14px", background: "#fff" }}>
// // // // //           <CardElement options={CARD_STYLE} />
// // // // //         </div>
// // // // //       </div>

// // // // //       {error && (
// // // // //         <div style={{ background: "var(--red-light)", color: "var(--red)", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 16 }}>
// // // // //           {error}
// // // // //         </div>
// // // // //       )}

// // // // //       {/* Order summary */}
// // // // //       <div style={{ background: "var(--gray-50)", borderRadius: 8, padding: "14px 16px", marginBottom: 20 }}>
// // // // //         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
// // // // //           <div>
// // // // //             <div style={{ fontWeight: 600, fontSize: 14, color: "var(--gray-900)" }}>{productName}</div>
// // // // //             <div style={{ fontSize: 12, color: "var(--gray-500)", marginTop: 2 }}>{planName} · One-time · No subscription</div>
// // // // //           </div>
// // // // //           <span style={{ fontWeight: 700, fontSize: 18, color: "var(--gray-900)" }}>{priceDisplay}</span>
// // // // //         </div>
// // // // //       </div>

// // // // //       <div style={{ display: "flex", gap: 10 }}>
// // // // //         <button
// // // // //           type="button"
// // // // //           className="btn btn-outline btn-full"
// // // // //           onClick={onClose}
// // // // //           disabled={loading}
// // // // //         >
// // // // //           Cancel
// // // // //         </button>
// // // // //         <button
// // // // //           type="submit"
// // // // //           className="btn btn-primary btn-full btn-lg"
// // // // //           disabled={!stripe || loading}
// // // // //         >
// // // // //           {loading
// // // // //             ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Processing...</>
// // // // //             : `Pay ${priceDisplay}`
// // // // //           }
// // // // //         </button>
// // // // //       </div>

// // // // //       <p style={{ fontSize: 11, color: "var(--gray-400)", textAlign: "center", marginTop: 12 }}>
// // // // //         🔒 Secured by Stripe. We never store your card details.
// // // // //       </p>
// // // // //     </form>
// // // // //   );
// // // // // }

// // // // // export default function PaymentModal({ onSuccess, onClose, userEmail, userName, planId, userId }) {
// // // // //   const [serverPlanPrice, setServerPlanPrice] = useState(null);
// // // // //   const [priceLoading,    setPriceLoading]    = useState(true);

// // // // //   // ── Fetch live price from server on mount ──
// // // // //   // Runs every time the modal opens — price always matches what Stripe charges.
// // // // //   useEffect(() => {
// // // // //     setPriceLoading(true);
// // // // //     fetch(`${apiConfig.BACKEND_URL}/config`, { signal: AbortSignal.timeout(5000) })
// // // // //       .then(r => r.json())
// // // // //       .then(d => {
// // // // //         if (d.plans?.[planId])        setServerPlanPrice(d.plans[planId]);
// // // // //         else if (d.plans?.ats_basic)  setServerPlanPrice(d.plans.ats_basic);
// // // // //       })
// // // // //       .catch(() => {}) // fall back to servicesConfig if server unreachable
// // // // //       .finally(() => setPriceLoading(false));
// // // // //   }, [planId]);

// // // // //   const paymentDetails = getPaymentDetails(planId || "ats_basic");
// // // // //   // Server price always wins — it reads from .env PRICE_ATS_BASIC
// // // // //   const priceDisplay = serverPlanPrice?.priceDisplay || paymentDetails?.priceDisplay || "$1.99";
// // // // //   const productName  = serverPlanPrice?.planName     || paymentDetails?.serviceName  || "ATS Resume Analysis";

// // // // //   // ── Track modal open ──
// // // // //   useState(() => {
// // // // //     if (userId) trackPaymentModalOpened(userId, planId).catch(() => {});
// // // // //   });

// // // // //   return (
// // // // //     <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
// // // // //       <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 440, padding: "32px 28px", position: "relative", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
// // // // //         <button onClick={onClose}
// // // // //           style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 20, color: "var(--gray-400)", cursor: "pointer", lineHeight: 1 }}>
// // // // //           ✕
// // // // //         </button>
// // // // //         <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 6, letterSpacing: "-0.015em" }}>
// // // // //           Complete your payment
// // // // //         </h2>
// // // // //         <p style={{ fontSize: 14, color: "var(--gray-500)", marginBottom: 24, display: "flex", alignItems: "center", gap: 8 }}>
// // // // //           {productName} —{" "}
// // // // //           {priceLoading
// // // // //             ? <span style={{ display: "inline-block", width: 40, height: 14, background: "#e2e8f0", borderRadius: 4, animation: "pulse 1.5s infinite" }} />
// // // // //             : <strong style={{ color: "#0f172a" }}>{priceDisplay}</strong>
// // // // //           }
// // // // //         </p>
// // // // //         <Elements stripe={stripePromise}>
// // // // //           <CheckoutForm
// // // // //             onSuccess={onSuccess}
// // // // //             onClose={onClose}
// // // // //             userEmail={userEmail}
// // // // //             userName={userName}
// // // // //             planId={planId || "ats_basic"}
// // // // //             userId={userId}
// // // // //             serverPlanPrice={serverPlanPrice}
// // // // //           />
// // // // //         </Elements>
// // // // //       </div>
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // import { useState, useRef, useEffect } from "react";
// // // // import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// // // // import { stripePromise } from "../utils/stripe";
// // // // import { getPaymentDetails } from "../utils/paymentConfig";
// // // // import { trackPaymentModalOpened, trackPaymentFailed } from "../utils/transactions";
// // // // import apiConfig from "../utils/apiConfig";

// // // // const CARD_STYLE = {
// // // //   style: {
// // // //     base: {
// // // //       fontSize: "15px",
// // // //       color: "#343A40",
// // // //       fontFamily: "'Inter', sans-serif",
// // // //       "::placeholder": { color: "#ADB5BD" },
// // // //     },
// // // //     invalid: { color: "#A32D2D" },
// // // //   },
// // // // };

// // // // function CheckoutForm({ onSuccess, onClose, userEmail, userName, planId, userId, serverPlanPrice }) {
// // // //   const stripe = useStripe();
// // // //   const elements = useElements();
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [error, setError] = useState("");
// // // //   const isSubmitting = useRef(false);

// // // //   // Price display: ONLY from server — never servicesConfig
// // // //   const paymentDetails = getPaymentDetails(planId || "ats_basic");
// // // //   const priceDisplay   = serverPlanPrice?.priceDisplay || "...";
// // // //   const productName    = serverPlanPrice?.planName     || paymentDetails?.serviceName || "ATS Resume Analysis";
// // // //   const planName       = paymentDetails?.planName      || "Pay Per Use";

// // // //   async function handlePay(e) {
// // // //     e.preventDefault();
// // // //     if (!stripe || !elements) return;
// // // //     if (isSubmitting.current) return; // ── Block double-click

// // // //     isSubmitting.current = true;
// // // //     setError("");
// // // //     setLoading(true);

// // // //     try {
// // // //       // ── Step 1: Create payment intent on server (amount set server-side) ──
// // // //       const intentRes = await fetch(`${apiConfig.BACKEND_URL}/create-payment-intent`, {
// // // //         method:  "POST",
// // // //         headers: { "Content-Type": "application/json" },
// // // //         body:    JSON.stringify({
// // // //           planId: planId || "ats_basic",
// // // //         }),
// // // //       });

// // // //       if (!intentRes.ok) {
// // // //         const { error: serverError } = await intentRes.json();
// // // //         throw new Error(serverError || "Could not initiate payment.");
// // // //       }

// // // //       const { clientSecret } = await intentRes.json();

// // // //       // ── Step 2: Confirm card payment with Stripe ──
// // // //       const { error: stripeErr, paymentIntent } = await stripe.confirmCardPayment(
// // // //         clientSecret,
// // // //         { payment_method: { card: elements.getElement(CardElement) } }
// // // //       );

// // // //       if (stripeErr) {
// // // //         setError(stripeErr.message);
// // // //         // Track payment failure
// // // //         await trackPaymentFailed(userId, planId, stripeErr.message).catch(() => {});
// // // //         // Notify server to send failure email
// // // //         fetch(`${apiConfig.BACKEND_URL}/email/payment-failed`, {
// // // //           method:  "POST",
// // // //           headers: { "Content-Type": "application/json" },
// // // //           body:    JSON.stringify({ userEmail, userName, errorMessage: stripeErr.message, amount: priceDisplay, planId }),
// // // //         }).catch(() => {});
// // // //         return;
// // // //       }

// // // //       if (paymentIntent.status === "succeeded") {
// // // //         // ── Step 3: Verify payment server-side before saving ──
// // // //         const verifyRes = await fetch(`${apiConfig.BACKEND_URL}/verify-payment`, {
// // // //           method:  "POST",
// // // //           headers: { "Content-Type": "application/json" },
// // // //           body:    JSON.stringify({ paymentIntentId: paymentIntent.id }),
// // // //         });

// // // //         const verifyData = await verifyRes.json();
// // // //         if (!verifyRes.ok) {
// // // //           throw new Error(verifyData.error || "Payment verification failed. Contact support.");
// // // //         }

// // // //         // ── Step 4: Trigger success email from server (not client) ──
// // // //         fetch(`${apiConfig.BACKEND_URL}/email/payment-success`, {
// // // //           method:  "POST",
// // // //           headers: { "Content-Type": "application/json" },
// // // //           body:    JSON.stringify({
// // // //             userEmail,
// // // //             userName,
// // // //             transactionId: paymentIntent.id,
// // // //             amount:        priceDisplay,
// // // //             planId,
// // // //           }),
// // // //         }).catch(() => {}); // fire and forget

// // // //         // ── Step 5: Hand verified data back to parent ──
// // // //         // amountPaid is cents from Stripe — the true price charged, frozen at payment time
// // // //         onSuccess(paymentIntent.id, verifyData.includes || null, {
// // // //           amountPaid:    verifyData.amountPaid,
// // // //           amountDisplay: verifyData.amountDisplay,
// // // //           currency:      verifyData.currency || "usd",
// // // //           planName:      verifyData.planName || planId,
// // // //         });
// // // //       }

// // // //     } catch (err) {
// // // //       const msg = err.message || "Payment failed. Please try again.";
// // // //       setError(msg);
// // // //       await trackPaymentFailed(userId, planId, msg).catch(() => {});
// // // //       // Notify server to send failure email
// // // //       fetch(`${apiConfig.BACKEND_URL}/email/payment-failed`, {
// // // //         method:  "POST",
// // // //         headers: { "Content-Type": "application/json" },
// // // //         body:    JSON.stringify({ userEmail, userName, errorMessage: msg, amount: priceDisplay }),
// // // //       }).catch(() => {});
// // // //     } finally {
// // // //       setLoading(false);
// // // //       isSubmitting.current = false;
// // // //     }
// // // //   }

// // // //   return (
// // // //     <form onSubmit={handlePay}>
// // // //       <div style={{ marginBottom: 20 }}>
// // // //         <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: "var(--gray-700)", marginBottom: 8 }}>
// // // //           Card details
// // // //         </label>
// // // //         <div style={{ border: "1.5px solid var(--gray-300)", borderRadius: 10, padding: "12px 14px", background: "#fff" }}>
// // // //           <CardElement options={CARD_STYLE} />
// // // //         </div>
// // // //       </div>

// // // //       {error && (
// // // //         <div style={{ background: "var(--red-light)", color: "var(--red)", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 16 }}>
// // // //           {error}
// // // //         </div>
// // // //       )}

// // // //       {/* Order summary */}
// // // //       <div style={{ background: "var(--gray-50)", borderRadius: 8, padding: "14px 16px", marginBottom: 20 }}>
// // // //         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
// // // //           <div>
// // // //             <div style={{ fontWeight: 600, fontSize: 14, color: "var(--gray-900)" }}>{productName}</div>
// // // //             <div style={{ fontSize: 12, color: "var(--gray-500)", marginTop: 2 }}>{planName} · One-time · No subscription</div>
// // // //           </div>
// // // //           {/* Show skeleton until server price arrives */}
// // // //           {priceDisplay === "..."
// // // //             ? <span style={{ display: "inline-block", width: 48, height: 20, background: "#e2e8f0", borderRadius: 4, animation: "pulse 1.5s infinite" }} />
// // // //             : <span style={{ fontWeight: 700, fontSize: 18, color: "var(--gray-900)" }}>{priceDisplay}</span>
// // // //           }
// // // //         </div>
// // // //       </div>

// // // //       <div style={{ display: "flex", gap: 10 }}>
// // // //         <button
// // // //           type="button"
// // // //           className="btn btn-outline btn-full"
// // // //           onClick={onClose}
// // // //           disabled={loading}
// // // //         >
// // // //           Cancel
// // // //         </button>
// // // //         <button
// // // //           type="submit"
// // // //           className="btn btn-primary btn-full btn-lg"
// // // //           disabled={!stripe || loading || priceDisplay === "..."}
// // // //         >
// // // //           {loading
// // // //             ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Processing...</>
// // // //             : priceDisplay === "..."
// // // //             ? "Loading price..."
// // // //             : `Pay ${priceDisplay}`
// // // //           }
// // // //         </button>
// // // //       </div>

// // // //       <p style={{ fontSize: 11, color: "var(--gray-400)", textAlign: "center", marginTop: 12 }}>
// // // //         🔒 Secured by Stripe. We never store your card details.
// // // //       </p>
// // // //     </form>
// // // //   );
// // // // }

// // // // export default function PaymentModal({ onSuccess, onClose, userEmail, userName, planId, userId }) {
// // // //   const [serverPlanPrice, setServerPlanPrice] = useState(null);
// // // //   const [priceLoading,    setPriceLoading]    = useState(true);

// // // //   // ── Fetch live price from server on mount ──
// // // //   // Runs every time the modal opens — price always matches what Stripe charges.
// // // //   useEffect(() => {
// // // //     setPriceLoading(true);
// // // //     fetch(`${apiConfig.BACKEND_URL}/config`, { signal: AbortSignal.timeout(5000) })
// // // //       .then(r => r.json())
// // // //       .then(d => {
// // // //         if (d.plans?.[planId])        setServerPlanPrice(d.plans[planId]);
// // // //         else if (d.plans?.ats_basic)  setServerPlanPrice(d.plans.ats_basic);
// // // //       })
// // // //       .catch(() => {}) // fall back to servicesConfig if server unreachable
// // // //       .finally(() => setPriceLoading(false));
// // // //   }, [planId]);

// // // //   const paymentDetails = getPaymentDetails(planId || "ats_basic");
// // // //   // ONLY use server price — never servicesConfig (which may be stale)
// // // //   // priceLoading=true until server responds, modal blocks Pay button during this time
// // // //   const priceDisplay = serverPlanPrice?.priceDisplay || (priceLoading ? "..." : "$2.99");
// // // //   const productName  = serverPlanPrice?.planName     || paymentDetails?.serviceName || "ATS Resume Analysis";

// // // //   // ── Track modal open ──
// // // //   useState(() => {
// // // //     if (userId) trackPaymentModalOpened(userId, planId).catch(() => {});
// // // //   });

// // // //   return (
// // // //     <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
// // // //       <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 440, padding: "32px 28px", position: "relative", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
// // // //         <button onClick={onClose}
// // // //           style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 20, color: "var(--gray-400)", cursor: "pointer", lineHeight: 1 }}>
// // // //           ✕
// // // //         </button>
// // // //         <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 6, letterSpacing: "-0.015em" }}>
// // // //           Complete your payment
// // // //         </h2>
// // // //         <p style={{ fontSize: 14, color: "var(--gray-500)", marginBottom: 24, display: "flex", alignItems: "center", gap: 8 }}>
// // // //           {productName} —{" "}
// // // //           {priceLoading
// // // //             ? <span style={{ display: "inline-block", width: 40, height: 14, background: "#e2e8f0", borderRadius: 4, animation: "pulse 1.5s infinite" }} />
// // // //             : <strong style={{ color: "#0f172a" }}>{priceDisplay}</strong>
// // // //           }
// // // //         </p>
// // // //         <Elements stripe={stripePromise}>
// // // //           <CheckoutForm
// // // //             onSuccess={onSuccess}
// // // //             onClose={onClose}
// // // //             userEmail={userEmail}
// // // //             userName={userName}
// // // //             planId={planId || "ats_basic"}
// // // //             userId={userId}
// // // //             serverPlanPrice={serverPlanPrice}
// // // //           />
// // // //         </Elements>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }

// // // import { useState, useRef, useEffect } from "react";
// // // import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// // // import { stripePromise } from "../utils/stripe";
// // // import { getPaymentDetails } from "../utils/paymentConfig";
// // // import { trackPaymentModalOpened, trackPaymentFailed } from "../utils/transactions";
// // // import apiConfig from "../utils/apiConfig";

// // // const CARD_STYLE = {
// // //   style: {
// // //     base: {
// // //       fontSize: "15px",
// // //       color: "#343A40",
// // //       fontFamily: "'Inter', sans-serif",
// // //       "::placeholder": { color: "#ADB5BD" },
// // //     },
// // //     invalid: { color: "#A32D2D" },
// // //   },
// // // };

// // // function CheckoutForm({ onSuccess, onClose, userEmail, userName, planId, userId, serverPlanPrice }) {
// // //   const stripe = useStripe();
// // //   const elements = useElements();
// // //   const [loading,    setLoading]    = useState(false);
// // //   const [error,      setError]      = useState("");
// // //   const [localPrice, setLocalPrice] = useState(null);
// // //   const isSubmitting = useRef(false);

// // //   // Price display: ONLY from server — never servicesConfig
// // //   const paymentDetails = getPaymentDetails(planId || "ats_basic");
// // //   const priceDisplay   = serverPlanPrice?.priceDisplay || "...";
// // //   const productName    = serverPlanPrice?.planName     || paymentDetails?.serviceName || "ATS Resume Analysis";
// // //   const planName       = paymentDetails?.planName      || "Pay Per Use";

// // //   // ── Browser locale currency conversion ──
// // //   useEffect(() => {
// // //     if (!serverPlanPrice?.priceInCents) return;
// // //     try {
// // //       const usdAmount = serverPlanPrice.priceInCents / 100;
// // //       const locale    = navigator.language || "en-US";
// // //       const region    = locale.split("-")[1] || "US";
// // //       const REGION_CURRENCY = { IN:"INR",GB:"GBP",AU:"AUD",CA:"CAD",DE:"EUR",FR:"EUR",IT:"EUR",ES:"EUR",JP:"JPY",SG:"SGD",AE:"AED" };
// // //       const currency  = REGION_CURRENCY[region];
// // //       if (!currency) { setLocalPrice(null); return; }
// // //       const RATES = { INR:84,GBP:0.79,AUD:1.53,CAD:1.36,EUR:0.92,JPY:150,SGD:1.34,AED:3.67 };
// // //       const rate = RATES[currency];
// // //       if (!rate) { setLocalPrice(null); return; }
// // //       const formatted = new Intl.NumberFormat(locale, { style:"currency", currency, maximumFractionDigits:0 }).format(Math.round(usdAmount * rate));
// // //       setLocalPrice(formatted);
// // //     } catch (_) { setLocalPrice(null); }
// // //   }, [serverPlanPrice]);

// // //   async function handlePay(e) {
// // //     e.preventDefault();
// // //     if (!stripe || !elements) return;
// // //     if (isSubmitting.current) return; // ── Block double-click

// // //     isSubmitting.current = true;
// // //     setError("");
// // //     setLoading(true);

// // //     try {
// // //       // ── Step 1: Create payment intent on server (amount set server-side) ──
// // //       const intentRes = await fetch(`${apiConfig.BACKEND_URL}/create-payment-intent`, {
// // //         method:  "POST",
// // //         headers: { "Content-Type": "application/json" },
// // //         body:    JSON.stringify({
// // //           planId: planId || "ats_basic",
// // //         }),
// // //       });

// // //       if (!intentRes.ok) {
// // //         const { error: serverError } = await intentRes.json();
// // //         throw new Error(serverError || "Could not initiate payment.");
// // //       }

// // //       const { clientSecret } = await intentRes.json();

// // //       // ── Step 2: Confirm card payment with Stripe ──
// // //       const { error: stripeErr, paymentIntent } = await stripe.confirmCardPayment(
// // //         clientSecret,
// // //         { payment_method: { card: elements.getElement(CardElement) } }
// // //       );

// // //       if (stripeErr) {
// // //         setError(stripeErr.message);
// // //         // Track payment failure
// // //         await trackPaymentFailed(userId, planId, stripeErr.message).catch(() => {});
// // //         // Notify server to send failure email
// // //         fetch(`${apiConfig.BACKEND_URL}/email/payment-failed`, {
// // //           method:  "POST",
// // //           headers: { "Content-Type": "application/json" },
// // //           body:    JSON.stringify({ userEmail, userName, errorMessage: stripeErr.message, amount: priceDisplay, planId }),
// // //         }).catch(() => {});
// // //         return;
// // //       }

// // //       if (paymentIntent.status === "succeeded") {
// // //         // ── Step 3: Verify payment server-side before saving ──
// // //         const verifyRes = await fetch(`${apiConfig.BACKEND_URL}/verify-payment`, {
// // //           method:  "POST",
// // //           headers: { "Content-Type": "application/json" },
// // //           body:    JSON.stringify({ paymentIntentId: paymentIntent.id }),
// // //         });

// // //         const verifyData = await verifyRes.json();
// // //         if (!verifyRes.ok) {
// // //           throw new Error(verifyData.error || "Payment verification failed. Contact support.");
// // //         }

// // //         // ── Step 4: Trigger success email from server (not client) ──
// // //         fetch(`${apiConfig.BACKEND_URL}/email/payment-success`, {
// // //           method:  "POST",
// // //           headers: { "Content-Type": "application/json" },
// // //           body:    JSON.stringify({
// // //             userEmail,
// // //             userName,
// // //             transactionId: paymentIntent.id,
// // //             amount:        priceDisplay,
// // //             planId,
// // //           }),
// // //         }).catch(() => {}); // fire and forget

// // //         // ── Step 5: Hand verified data back to parent ──
// // //         // amountPaid is cents from Stripe — the true price charged, frozen at payment time
// // //         onSuccess(paymentIntent.id, verifyData.includes || null, {
// // //           amountPaid:    verifyData.amountPaid,
// // //           amountDisplay: verifyData.amountDisplay,
// // //           currency:      verifyData.currency || "usd",
// // //           planName:      verifyData.planName || planId,
// // //         });
// // //       }

// // //     } catch (err) {
// // //       const msg = err.message || "Payment failed. Please try again.";
// // //       setError(msg);
// // //       await trackPaymentFailed(userId, planId, msg).catch(() => {});
// // //       // Notify server to send failure email
// // //       fetch(`${apiConfig.BACKEND_URL}/email/payment-failed`, {
// // //         method:  "POST",
// // //         headers: { "Content-Type": "application/json" },
// // //         body:    JSON.stringify({ userEmail, userName, errorMessage: msg, amount: priceDisplay }),
// // //       }).catch(() => {});
// // //     } finally {
// // //       setLoading(false);
// // //       isSubmitting.current = false;
// // //     }
// // //   }

// // //   return (
// // //     <form onSubmit={handlePay}>
// // //       <div style={{ marginBottom: 20 }}>
// // //         <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: "var(--gray-700)", marginBottom: 8 }}>
// // //           Card details
// // //         </label>
// // //         <div style={{ border: "1.5px solid var(--gray-300)", borderRadius: 10, padding: "12px 14px", background: "#fff" }}>
// // //           <CardElement options={CARD_STYLE} />
// // //         </div>
// // //       </div>

// // //       {error && (
// // //         <div style={{ background: "var(--red-light)", color: "var(--red)", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 16 }}>
// // //           {error}
// // //         </div>
// // //       )}

// // //       {/* Order summary */}
// // //       <div style={{ background: "var(--gray-50)", borderRadius: 8, padding: "14px 16px", marginBottom: 20 }}>
// // //         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
// // //           <div>
// // //             <div style={{ fontWeight: 600, fontSize: 14, color: "var(--gray-900)" }}>{productName}</div>
// // //             <div style={{ fontSize: 12, color: "var(--gray-500)", marginTop: 2 }}>{planName} · One-time · No subscription</div>
// // //           </div>
// // //           {/* Show skeleton until server price arrives */}
// // //           {priceDisplay === "..."
// // //             ? <span style={{ display: "inline-block", width: 48, height: 20, background: "#e2e8f0", borderRadius: 4, animation: "pulse 1.5s infinite" }} />
// // //             : <div style={{ textAlign: "right" }}>
// // //                 <span style={{ fontWeight: 700, fontSize: 18, color: "var(--gray-900)", display: "block" }}>{priceDisplay}</span>
// // //                 {localPrice && (
// // //                   <span style={{ fontSize: 11, color: "#64748b" }}>≈ {localPrice}</span>
// // //                 )}
// // //               </div>
// // //           }
// // //         </div>
// // //       </div>

// // //       <div style={{ display: "flex", gap: 10 }}>
// // //         <button
// // //           type="button"
// // //           className="btn btn-outline btn-full"
// // //           onClick={onClose}
// // //           disabled={loading}
// // //         >
// // //           Cancel
// // //         </button>
// // //         <button
// // //           type="submit"
// // //           className="btn btn-primary btn-full btn-lg"
// // //           disabled={!stripe || loading || priceDisplay === "..."}
// // //         >
// // //           {loading
// // //             ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Processing...</>
// // //             : priceDisplay === "..."
// // //             ? "Loading price..."
// // //             : `Pay ${priceDisplay}`
// // //           }
// // //         </button>
// // //       </div>

// // //       <p style={{ fontSize: 11, color: "var(--gray-400)", textAlign: "center", marginTop: 12 }}>
// // //         🔒 Secured by Stripe. We never store your card details.
// // //       </p>
// // //     </form>
// // //   );
// // // }

// // // export default function PaymentModal({ onSuccess, onClose, userEmail, userName, planId, userId }) {
// // //   const [serverPlanPrice, setServerPlanPrice] = useState(null);
// // //   const [priceLoading,    setPriceLoading]    = useState(true);

// // //   // ── Fetch live price from server on mount ──
// // //   // Runs every time the modal opens — price always matches what Stripe charges.
// // //   useEffect(() => {
// // //     setPriceLoading(true);
// // //     fetch(`${apiConfig.BACKEND_URL}/config`, { signal: AbortSignal.timeout(5000) })
// // //       .then(r => r.json())
// // //       .then(d => {
// // //         const plan = d.plans?.[planId] || d.plans?.ats_basic;
// // //         if (plan) setServerPlanPrice(plan);
// // //       })
// // //       .catch(() => {}) // fall back to servicesConfig if server unreachable
// // //       .finally(() => setPriceLoading(false));
// // //   }, [planId]);

// // //   const paymentDetails = getPaymentDetails(planId || "ats_basic");
// // //   // ONLY use server price — never servicesConfig (which may be stale)
// // //   // priceLoading=true until server responds, modal blocks Pay button during this time
// // //   const priceDisplay      = serverPlanPrice?.priceDisplay      || (priceLoading ? "..." : "$2.99");
// // //   const productName = serverPlanPrice?.planName || paymentDetails?.serviceName || "ATS Resume Analysis";

// // //   // ── Track modal open ──
// // //   useState(() => {
// // //     if (userId) trackPaymentModalOpened(userId, planId).catch(() => {});
// // //   });

// // //   return (
// // //     <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
// // //       <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 440, padding: "32px 28px", position: "relative", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
// // //         <button onClick={onClose}
// // //           style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 20, color: "var(--gray-400)", cursor: "pointer", lineHeight: 1 }}>
// // //           ✕
// // //         </button>
// // //         <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 6, letterSpacing: "-0.015em" }}>
// // //           Complete your payment
// // //         </h2>
// // //         <p style={{ fontSize: 14, color: "var(--gray-500)", marginBottom: 24, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
// // //           {productName} —{" "}
// // //           {priceLoading
// // //             ? <span style={{ display: "inline-block", width: 40, height: 14, background: "#e2e8f0", borderRadius: 4, animation: "pulse 1.5s infinite" }} />
// // //             : <strong style={{ color: "#0f172a" }}>{priceDisplay}</strong>
// // //           }
// // //         </p>
// // //         <Elements stripe={stripePromise}>
// // //           <CheckoutForm
// // //             onSuccess={onSuccess}
// // //             onClose={onClose}
// // //             userEmail={userEmail}
// // //             userName={userName}
// // //             planId={planId || "ats_basic"}
// // //             userId={userId}
// // //             serverPlanPrice={serverPlanPrice}
// // //           />
// // //         </Elements>
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // import { useState, useRef, useEffect } from "react";
// // import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// // import { stripePromise } from "../utils/stripe";
// // import { getPaymentDetails } from "../utils/paymentConfig";
// // import { trackPaymentModalOpened, trackPaymentFailed } from "../utils/transactions";
// // import apiConfig from "../utils/apiConfig";

// // const CARD_STYLE = {
// //   style: {
// //     base: {
// //       fontSize: "15px",
// //       color: "#343A40",
// //       fontFamily: "'Inter', sans-serif",
// //       "::placeholder": { color: "#ADB5BD" },
// //     },
// //     invalid: { color: "#A32D2D" },
// //   },
// // };

// // function CheckoutForm({ onSuccess, onClose, userEmail, userName, planId, userId, serverPlanPrice }) {
// //   const stripe = useStripe();
// //   const elements = useElements();
// //   const [loading,    setLoading]    = useState(false);
// //   const [error,      setError]      = useState("");
// //   const [localPrice, setLocalPrice] = useState(null);
// //   const isSubmitting = useRef(false);

// //   // Price display: ONLY from server — never servicesConfig
// //   const paymentDetails = getPaymentDetails(planId || "ats_basic");
// //   const priceDisplay   = serverPlanPrice?.priceDisplay || "...";
// //   const productName    = serverPlanPrice?.planName     || paymentDetails?.serviceName || "ATS Resume Analysis";
// //   const planName       = paymentDetails?.planName      || "Pay Per Use";

// //   // ── Browser locale currency conversion ──
// //   useEffect(() => {
// //     if (!serverPlanPrice?.priceInCents) return;
// //     try {
// //       const usdAmount = serverPlanPrice.priceInCents / 100;
// //       const langs     = navigator.languages?.length ? navigator.languages : [navigator.language || "en-US"];
// //       const locale    = langs[0] || "en-US";
// //       const parts     = locale.split("-");
// //       const region    = parts[parts.length - 1]?.toUpperCase();

// //       const USD_REGIONS = ["US","AS","EC","PR","SV","GU","MH","FM","MP","PW","TC","VI","ZW","BZ","PA"];
// //       if (!region || USD_REGIONS.includes(region)) { setLocalPrice(null); return; }

// //       const REGION_CURRENCY = {
// //         IN:"INR", GB:"GBP", AU:"AUD", CA:"CAD",
// //         DE:"EUR", FR:"EUR", IT:"EUR", ES:"EUR", NL:"EUR", BE:"EUR", PT:"EUR", AT:"EUR",
// //         JP:"JPY", SG:"SGD", AE:"AED", ZA:"ZAR", BR:"BRL", MX:"MXN", NZ:"NZD",
// //       };
// //       const currency = REGION_CURRENCY[region];
// //       if (!currency) { setLocalPrice(null); return; }

// //       const RATES = { INR:84, GBP:0.79, AUD:1.53, CAD:1.36, EUR:0.92, JPY:150, SGD:1.34, AED:3.67, ZAR:18.5, BRL:5.0, MXN:17.5, NZD:1.65 };
// //       const rate = RATES[currency];
// //       if (!rate) { setLocalPrice(null); return; }

// //       const formatted = new Intl.NumberFormat(locale, { style:"currency", currency, maximumFractionDigits:0 }).format(Math.round(usdAmount * rate));
// //       setLocalPrice(formatted);
// //     } catch (_) { setLocalPrice(null); }
// //   }, [serverPlanPrice]);

// //   async function handlePay(e) {
// //     e.preventDefault();
// //     if (!stripe || !elements) return;
// //     if (isSubmitting.current) return; // ── Block double-click

// //     isSubmitting.current = true;
// //     setError("");
// //     setLoading(true);

// //     try {
// //       // ── Step 1: Create payment intent on server (amount set server-side) ──
// //       const intentRes = await fetch(`${apiConfig.BACKEND_URL}/create-payment-intent`, {
// //         method:  "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body:    JSON.stringify({
// //           planId: planId || "ats_basic",
// //         }),
// //       });

// //       if (!intentRes.ok) {
// //         const { error: serverError } = await intentRes.json();
// //         throw new Error(serverError || "Could not initiate payment.");
// //       }

// //       const { clientSecret } = await intentRes.json();

// //       // ── Step 2: Confirm card payment with Stripe ──
// //       const { error: stripeErr, paymentIntent } = await stripe.confirmCardPayment(
// //         clientSecret,
// //         { payment_method: { card: elements.getElement(CardElement) } }
// //       );

// //       if (stripeErr) {
// //         setError(stripeErr.message);
// //         // Track payment failure
// //         await trackPaymentFailed(userId, planId, stripeErr.message).catch(() => {});
// //         // Notify server to send failure email
// //         fetch(`${apiConfig.BACKEND_URL}/email/payment-failed`, {
// //           method:  "POST",
// //           headers: { "Content-Type": "application/json" },
// //           body:    JSON.stringify({ userEmail, userName, errorMessage: stripeErr.message, amount: priceDisplay, planId }),
// //         }).catch(() => {});
// //         return;
// //       }

// //       if (paymentIntent.status === "succeeded") {
// //         // ── Step 3: Verify payment server-side before saving ──
// //         const verifyRes = await fetch(`${apiConfig.BACKEND_URL}/verify-payment`, {
// //           method:  "POST",
// //           headers: { "Content-Type": "application/json" },
// //           body:    JSON.stringify({ paymentIntentId: paymentIntent.id }),
// //         });

// //         const verifyData = await verifyRes.json();
// //         if (!verifyRes.ok) {
// //           throw new Error(verifyData.error || "Payment verification failed. Contact support.");
// //         }

// //         // ── Step 4: Trigger success email from server (not client) ──
// //         fetch(`${apiConfig.BACKEND_URL}/email/payment-success`, {
// //           method:  "POST",
// //           headers: { "Content-Type": "application/json" },
// //           body:    JSON.stringify({
// //             userEmail,
// //             userName,
// //             transactionId: paymentIntent.id,
// //             amount:        priceDisplay,
// //             planId,
// //           }),
// //         }).catch(() => {}); // fire and forget

// //         // ── Step 5: Hand verified data back to parent ──
// //         // amountPaid is cents from Stripe — the true price charged, frozen at payment time
// //         onSuccess(paymentIntent.id, verifyData.includes || null, {
// //           amountPaid:    verifyData.amountPaid,
// //           amountDisplay: verifyData.amountDisplay,
// //           currency:      verifyData.currency || "usd",
// //           planName:      verifyData.planName || planId,
// //         });
// //       }

// //     } catch (err) {
// //       const msg = err.message || "Payment failed. Please try again.";
// //       setError(msg);
// //       await trackPaymentFailed(userId, planId, msg).catch(() => {});
// //       // Notify server to send failure email
// //       fetch(`${apiConfig.BACKEND_URL}/email/payment-failed`, {
// //         method:  "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body:    JSON.stringify({ userEmail, userName, errorMessage: msg, amount: priceDisplay }),
// //       }).catch(() => {});
// //     } finally {
// //       setLoading(false);
// //       isSubmitting.current = false;
// //     }
// //   }

// //   return (
// //     <form onSubmit={handlePay}>
// //       <div style={{ marginBottom: 20 }}>
// //         <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: "var(--gray-700)", marginBottom: 8 }}>
// //           Card details
// //         </label>
// //         <div style={{ border: "1.5px solid var(--gray-300)", borderRadius: 10, padding: "12px 14px", background: "#fff" }}>
// //           <CardElement options={CARD_STYLE} />
// //         </div>
// //       </div>

// //       {error && (
// //         <div style={{ background: "var(--red-light)", color: "var(--red)", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 16 }}>
// //           {error}
// //         </div>
// //       )}

// //       {/* Order summary */}
// //       <div style={{ background: "var(--gray-50)", borderRadius: 8, padding: "14px 16px", marginBottom: 20 }}>
// //         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
// //           <div>
// //             <div style={{ fontWeight: 600, fontSize: 14, color: "var(--gray-900)" }}>{productName}</div>
// //             <div style={{ fontSize: 12, color: "var(--gray-500)", marginTop: 2 }}>{planName} · One-time · No subscription</div>
// //           </div>
// //           {/* Show skeleton until server price arrives */}
// //           {priceDisplay === "..."
// //             ? <span style={{ display: "inline-block", width: 48, height: 20, background: "#e2e8f0", borderRadius: 4, animation: "pulse 1.5s infinite" }} />
// //             : <div style={{ textAlign: "right" }}>
// //                 <span style={{ fontWeight: 700, fontSize: 18, color: "var(--gray-900)", display: "block" }}>{priceDisplay}</span>
// //                 {localPrice && (
// //                   <span style={{ fontSize: 11, color: "#64748b" }}>≈ {localPrice}</span>
// //                 )}
// //               </div>
// //           }
// //         </div>
// //       </div>

// //       <div style={{ display: "flex", gap: 10 }}>
// //         <button
// //           type="button"
// //           className="btn btn-outline btn-full"
// //           onClick={onClose}
// //           disabled={loading}
// //         >
// //           Cancel
// //         </button>
// //         <button
// //           type="submit"
// //           className="btn btn-primary btn-full btn-lg"
// //           disabled={!stripe || loading || priceDisplay === "..."}
// //         >
// //           {loading
// //             ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Processing...</>
// //             : priceDisplay === "..."
// //             ? "Loading price..."
// //             : `Pay ${priceDisplay}`
// //           }
// //         </button>
// //       </div>

// //       <p style={{ fontSize: 11, color: "var(--gray-400)", textAlign: "center", marginTop: 12 }}>
// //         🔒 Secured by Stripe. We never store your card details.
// //       </p>
// //     </form>
// //   );
// // }

// // export default function PaymentModal({ onSuccess, onClose, userEmail, userName, planId, userId }) {
// //   const [serverPlanPrice, setServerPlanPrice] = useState(null);
// //   const [priceLoading,    setPriceLoading]    = useState(true);

// //   // ── Fetch live price from server on mount ──
// //   // Runs every time the modal opens — price always matches what Stripe charges.
// //   useEffect(() => {
// //     setPriceLoading(true);
// //     fetch(`${apiConfig.BACKEND_URL}/config`, { signal: AbortSignal.timeout(5000) })
// //       .then(r => r.json())
// //       .then(d => {
// //         const plan = d.plans?.[planId] || d.plans?.ats_basic;
// //         if (plan) setServerPlanPrice(plan);
// //       })
// //       .catch(() => {}) // fall back to servicesConfig if server unreachable
// //       .finally(() => setPriceLoading(false));
// //   }, [planId]);

// //   const paymentDetails = getPaymentDetails(planId || "ats_basic");
// //   // ONLY use server price — never servicesConfig (which may be stale)
// //   // priceLoading=true until server responds, modal blocks Pay button during this time
// //   const priceDisplay      = serverPlanPrice?.priceDisplay      || (priceLoading ? "..." : "$2.99");
// //   const productName = serverPlanPrice?.planName || paymentDetails?.serviceName || "ATS Resume Analysis";

// //   // ── Track modal open ──
// //   useState(() => {
// //     if (userId) trackPaymentModalOpened(userId, planId).catch(() => {});
// //   });

// //   return (
// //     <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
// //       <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 440, padding: "32px 28px", position: "relative", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
// //         <button onClick={onClose}
// //           style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 20, color: "var(--gray-400)", cursor: "pointer", lineHeight: 1 }}>
// //           ✕
// //         </button>
// //         <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 6, letterSpacing: "-0.015em" }}>
// //           Complete your payment
// //         </h2>
// //         <p style={{ fontSize: 14, color: "var(--gray-500)", marginBottom: 24, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
// //           {productName} —{" "}
// //           {priceLoading
// //             ? <span style={{ display: "inline-block", width: 40, height: 14, background: "#e2e8f0", borderRadius: 4, animation: "pulse 1.5s infinite" }} />
// //             : <strong style={{ color: "#0f172a" }}>{priceDisplay}</strong>
// //           }
// //         </p>
// //         <Elements stripe={stripePromise}>
// //           <CheckoutForm
// //             onSuccess={onSuccess}
// //             onClose={onClose}
// //             userEmail={userEmail}
// //             userName={userName}
// //             planId={planId || "ats_basic"}
// //             userId={userId}
// //             serverPlanPrice={serverPlanPrice}
// //           />
// //         </Elements>
// //       </div>
// //     </div>
// //   );
// // }

// import { useState, useRef, useEffect } from "react";
// import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// import { stripePromise } from "../utils/stripe";
// import { getPaymentDetails } from "../utils/paymentConfig";
// import { trackPaymentModalOpened, trackPaymentFailed } from "../utils/transactions";
// import apiConfig from "../utils/apiConfig";

// const CARD_STYLE = {
//   style: {
//     base: {
//       fontSize: "15px",
//       color: "#343A40",
//       fontFamily: "'Inter', sans-serif",
//       "::placeholder": { color: "#ADB5BD" },
//     },
//     invalid: { color: "#A32D2D" },
//   },
// };

// function CheckoutForm({ onSuccess, onClose, userEmail, userName, planId, userId, serverPlanPrice }) {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [loading,    setLoading]    = useState(false);
//   const [error,      setError]      = useState("");
//   const [localPrice, setLocalPrice] = useState(null);
//   const isSubmitting = useRef(false);

//   // Price display: ONLY from server — never servicesConfig
//   const paymentDetails = getPaymentDetails(planId || "ats_basic");
//   const priceDisplay   = serverPlanPrice?.priceDisplay || "...";
//   const productName    = serverPlanPrice?.planName     || paymentDetails?.serviceName || "ATS Resume Analysis";
//   const planName       = paymentDetails?.planName      || "Pay Per Use";

//   // ── Live currency conversion — fetches real rates, cached 1hr in sessionStorage ──
//   useEffect(() => {
//     if (!serverPlanPrice?.priceInCents) return;

//     const langs    = navigator.languages?.length ? navigator.languages : [navigator.language || "en-US"];
//     const locale   = langs[0] || "en-US";
//     const parts    = locale.split("-");
//     const region   = parts[parts.length - 1]?.toUpperCase();

//     const USD_REGIONS = ["US","AS","EC","PR","SV","GU","MH","FM","MP","PW","TC","VI","ZW","BZ","PA"];
//     if (!region || USD_REGIONS.includes(region)) { setLocalPrice(null); return; }

//     const REGION_CURRENCY = {
//       IN:"INR", GB:"GBP", AU:"AUD", CA:"CAD",
//       DE:"EUR", FR:"EUR", IT:"EUR", ES:"EUR", NL:"EUR", BE:"EUR", PT:"EUR", AT:"EUR",
//       JP:"JPY", SG:"SGD", AE:"AED", ZA:"ZAR", BR:"BRL", MX:"MXN", NZ:"NZD",
//     };
//     const currency = REGION_CURRENCY[region];
//     if (!currency) { setLocalPrice(null); return; }

//     const usdAmount = serverPlanPrice.priceInCents / 100;
//     const CACHE_KEY = "fx_usd_rates_v1";
//     const CACHE_TTL = 60 * 60 * 1000; // 1 hour

//     // Fallback rates if API is unreachable
//     const FALLBACK  = { INR:84, GBP:0.79, AUD:1.53, CAD:1.36, EUR:0.92, JPY:150, SGD:1.34, AED:3.67, ZAR:18.5, BRL:5.0, MXN:17.5, NZD:1.65 };

//     async function fetchAndDisplay() {
//       let rate = null;
//       try {
//         // Try cache first
//         const cached = sessionStorage.getItem(CACHE_KEY);
//         if (cached) {
//           const { rates, ts } = JSON.parse(cached);
//           if (Date.now() - ts < CACHE_TTL && rates[currency]) {
//             rate = rates[currency];
//           }
//         }
//         // Fetch live if no valid cache — free API, no key needed
//         if (!rate) {
//           const res  = await fetch("https://api.exchangerate-api.com/v4/latest/USD", { signal: AbortSignal.timeout(5000) });
//           const data = await res.json();
//           sessionStorage.setItem(CACHE_KEY, JSON.stringify({ rates: data.rates, ts: Date.now() }));
//           rate = data.rates[currency];
//         }
//       } catch (_) {
//         rate = FALLBACK[currency] || null;
//       }
//       if (!rate) { setLocalPrice(null); return; }
//       const formatted = new Intl.NumberFormat(locale, {
//         style: "currency", currency, maximumFractionDigits: 0,
//       }).format(Math.round(usdAmount * rate));
//       setLocalPrice(formatted);
//     }

//     fetchAndDisplay();
//   }, [serverPlanPrice]);

//   async function handlePay(e) {
//     e.preventDefault();
//     if (!stripe || !elements) return;
//     if (isSubmitting.current) return; // ── Block double-click

//     isSubmitting.current = true;
//     setError("");
//     setLoading(true);

//     try {
//       // ── Step 1: Create payment intent on server (amount set server-side) ──
//       const intentRes = await fetch(`${apiConfig.BACKEND_URL}/create-payment-intent`, {
//         method:  "POST",
//         headers: { "Content-Type": "application/json" },
//         body:    JSON.stringify({
//           planId: planId || "ats_basic",
//         }),
//       });

//       if (!intentRes.ok) {
//         const { error: serverError } = await intentRes.json();
//         throw new Error(serverError || "Could not initiate payment.");
//       }

//       const { clientSecret } = await intentRes.json();

//       // ── Step 2: Confirm card payment with Stripe ──
//       const { error: stripeErr, paymentIntent } = await stripe.confirmCardPayment(
//         clientSecret,
//         { payment_method: { card: elements.getElement(CardElement) } }
//       );

//       if (stripeErr) {
//         setError(stripeErr.message);
//         // Track payment failure
//         await trackPaymentFailed(userId, planId, stripeErr.message).catch(() => {});
//         // Notify server to send failure email
//         fetch(`${apiConfig.BACKEND_URL}/email/payment-failed`, {
//           method:  "POST",
//           headers: { "Content-Type": "application/json" },
//           body:    JSON.stringify({ userEmail, userName, errorMessage: stripeErr.message, amount: priceDisplay, planId }),
//         }).catch(() => {});
//         return;
//       }

//       if (paymentIntent.status === "succeeded") {
//         // ── Step 3: Verify payment server-side before saving ──
//         const verifyRes = await fetch(`${apiConfig.BACKEND_URL}/verify-payment`, {
//           method:  "POST",
//           headers: { "Content-Type": "application/json" },
//           body:    JSON.stringify({ paymentIntentId: paymentIntent.id }),
//         });

//         const verifyData = await verifyRes.json();
//         if (!verifyRes.ok) {
//           throw new Error(verifyData.error || "Payment verification failed. Contact support.");
//         }

//         // ── Step 4: Trigger success email from server (not client) ──
//         fetch(`${apiConfig.BACKEND_URL}/email/payment-success`, {
//           method:  "POST",
//           headers: { "Content-Type": "application/json" },
//           body:    JSON.stringify({
//             userEmail,
//             userName,
//             transactionId: paymentIntent.id,
//             amount:        priceDisplay,
//             planId,
//           }),
//         }).catch(() => {}); // fire and forget

//         // ── Step 5: Hand verified data back to parent ──
//         // amountPaid is cents from Stripe — the true price charged, frozen at payment time
//         onSuccess(paymentIntent.id, verifyData.includes || null, {
//           amountPaid:    verifyData.amountPaid,
//           amountDisplay: verifyData.amountDisplay,
//           currency:      verifyData.currency || "usd",
//           planName:      verifyData.planName || planId,
//         });
//       }

//     } catch (err) {
//       const msg = err.message || "Payment failed. Please try again.";
//       setError(msg);
//       await trackPaymentFailed(userId, planId, msg).catch(() => {});
//       // Notify server to send failure email
//       fetch(`${apiConfig.BACKEND_URL}/email/payment-failed`, {
//         method:  "POST",
//         headers: { "Content-Type": "application/json" },
//         body:    JSON.stringify({ userEmail, userName, errorMessage: msg, amount: priceDisplay }),
//       }).catch(() => {});
//     } finally {
//       setLoading(false);
//       isSubmitting.current = false;
//     }
//   }

//   return (
//     <form onSubmit={handlePay}>
//       <div style={{ marginBottom: 20 }}>
//         <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: "var(--gray-700)", marginBottom: 8 }}>
//           Card details
//         </label>
//         <div style={{ border: "1.5px solid var(--gray-300)", borderRadius: 10, padding: "12px 14px", background: "#fff" }}>
//           <CardElement options={CARD_STYLE} />
//         </div>
//       </div>

//       {error && (
//         <div style={{ background: "var(--red-light)", color: "var(--red)", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 16 }}>
//           {error}
//         </div>
//       )}

//       {/* Order summary */}
//       <div style={{ background: "var(--gray-50)", borderRadius: 8, padding: "14px 16px", marginBottom: 20 }}>
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
//           <div>
//             <div style={{ fontWeight: 600, fontSize: 14, color: "var(--gray-900)" }}>{productName}</div>
//             <div style={{ fontSize: 12, color: "var(--gray-500)", marginTop: 2 }}>{planName} · One-time · No subscription</div>
//           </div>
//           {/* Show skeleton until server price arrives */}
//           {priceDisplay === "..."
//             ? <span style={{ display: "inline-block", width: 48, height: 20, background: "#e2e8f0", borderRadius: 4, animation: "pulse 1.5s infinite" }} />
//             : <div style={{ textAlign: "right" }}>
//                 <span style={{ fontWeight: 700, fontSize: 18, color: "var(--gray-900)", display: "block" }}>{priceDisplay}</span>
//                 {localPrice && (
//                   <span style={{ fontSize: 11, color: "#64748b" }}>≈ {localPrice}</span>
//                 )}
//               </div>
//           }
//         </div>
//       </div>

//       <div style={{ display: "flex", gap: 10 }}>
//         <button
//           type="button"
//           className="btn btn-outline btn-full"
//           onClick={onClose}
//           disabled={loading}
//         >
//           Cancel
//         </button>
//         <button
//           type="submit"
//           className="btn btn-primary btn-full btn-lg"
//           disabled={!stripe || loading || priceDisplay === "..."}
//         >
//           {loading
//             ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Processing...</>
//             : priceDisplay === "..."
//             ? "Loading price..."
//             : `Pay ${priceDisplay}`
//           }
//         </button>
//       </div>

//       <p style={{ fontSize: 11, color: "var(--gray-400)", textAlign: "center", marginTop: 12 }}>
//         🔒 Secured by Stripe. We never store your card details.
//       </p>
//     </form>
//   );
// }

// export default function PaymentModal({ onSuccess, onClose, userEmail, userName, planId, userId }) {
//   const [serverPlanPrice, setServerPlanPrice] = useState(null);
//   const [priceLoading,    setPriceLoading]    = useState(true);

//   // ── Fetch live price from server on mount ──
//   // Runs every time the modal opens — price always matches what Stripe charges.
//   useEffect(() => {
//     setPriceLoading(true);
//     fetch(`${apiConfig.BACKEND_URL}/config`, { signal: AbortSignal.timeout(5000) })
//       .then(r => r.json())
//       .then(d => {
//         const plan = d.plans?.[planId] || d.plans?.ats_basic;
//         if (plan) setServerPlanPrice(plan);
//       })
//       .catch(() => {}) // fall back to servicesConfig if server unreachable
//       .finally(() => setPriceLoading(false));
//   }, [planId]);

//   const paymentDetails = getPaymentDetails(planId || "ats_basic");
//   // ONLY use server price — never servicesConfig (which may be stale)
//   // priceLoading=true until server responds, modal blocks Pay button during this time
//   const priceDisplay      = serverPlanPrice?.priceDisplay      || (priceLoading ? "..." : "$2.99");
//   const productName = serverPlanPrice?.planName || paymentDetails?.serviceName || "ATS Resume Analysis";

//   // ── Track modal open ──
//   useState(() => {
//     if (userId) trackPaymentModalOpened(userId, planId).catch(() => {});
//   });

//   return (
//     <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
//       <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 440, padding: "32px 28px", position: "relative", boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}>
//         <button onClick={onClose}
//           style={{ position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 20, color: "var(--gray-400)", cursor: "pointer", lineHeight: 1 }}>
//           ✕
//         </button>
//         <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 6, letterSpacing: "-0.015em" }}>
//           Complete your payment
//         </h2>
//         <p style={{ fontSize: 14, color: "var(--gray-500)", marginBottom: 24, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
//           {productName} —{" "}
//           {priceLoading
//             ? <span style={{ display: "inline-block", width: 40, height: 14, background: "#e2e8f0", borderRadius: 4, animation: "pulse 1.5s infinite" }} />
//             : <strong style={{ color: "#0f172a" }}>{priceDisplay}</strong>
//           }
//         </p>
//         <Elements stripe={stripePromise}>
//           <CheckoutForm
//             onSuccess={onSuccess}
//             onClose={onClose}
//             userEmail={userEmail}
//             userName={userName}
//             planId={planId || "ats_basic"}
//             userId={userId}
//             serverPlanPrice={serverPlanPrice}
//           />
//         </Elements>
//       </div>
//     </div>
//   );
// }


// new code for price
// eslint-disable-next-line no-unused-vars
import { useState, useEffect } from "react";
import { CardElement, useStripe, useElements, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { usePricing, ModalPriceDisplay, StripeLocalNote } from "../hooks/usePricing";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://ats-app-795v.onrender.com";

// Stripe publishable key — set in .env as REACT_APP_STRIPE_PUBLISHABLE_KEY
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "");

//console.log(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// ─────────────────────────────────────────────
// CARD STYLES — matches the rest of the app UI
// ─────────────────────────────────────────────
const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize:        "15px",
      color:           "#0f172a",
      fontFamily:      "'Inter', -apple-system, sans-serif",
      fontSmoothing:   "antialiased",
      "::placeholder": { color: "#94a3b8" },
    },
    invalid: { color: "#dc2626", iconColor: "#dc2626" },
  },
};

// ─────────────────────────────────────────────
// INNER FORM — rendered inside Elements provider
// ─────────────────────────────────────────────
function CheckoutForm({ planId, userEmail, userName, userId, onSuccess, onClose }) {
  const stripe   = useStripe();
  const elements = useElements();

  const [loading,   setLoading]   = useState(false);
  const [error,     setError]     = useState("");
  const [cardReady, setCardReady] = useState(false);

  // Live localised pricing
  const { usdDisplay, localDisplay, usdCents } = usePricing(planId);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!stripe || !elements) return;
    setError("");
    setLoading(true);

    try {
      // Step 1 — create payment intent on server (amount set server-side)
      const intentRes = await fetch(`${BACKEND}/create-payment-intent`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ planId }),
      });
      if (!intentRes.ok) {
        const d = await intentRes.json().catch(() => ({}));
        throw new Error(d.error || `Server error ${intentRes.status}`);
      }
      const { clientSecret } = await intentRes.json();

      // Step 2 — confirm card payment with Stripe
      const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card:            elements.getElement(CardElement),
          billing_details: { name: userName || userEmail, email: userEmail },
        },
      });

      if (stripeError) throw new Error(stripeError.message);
      if (paymentIntent.status !== "succeeded") throw new Error("Payment not confirmed.");

      // Step 3 — verify on server
      const verifyRes = await fetch(`${BACKEND}/verify-payment`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ paymentIntentId: paymentIntent.id }),
      });
      if (!verifyRes.ok) throw new Error("Payment verification failed.");
      const paymentMeta = await verifyRes.json();

      // Step 4 — send success email (non-blocking)
      fetch(`${BACKEND}/email/payment-success`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({
          userEmail,
          userName,
          transactionId: paymentIntent.id,
          amount:        usdCents,
          serviceCode:   planId,
        }),
      }).catch(() => {});

      // Step 5 — notify parent
      onSuccess(paymentIntent.id, paymentMeta.includes || [], paymentMeta);

    } catch (err) {
      setError(err.message || "Payment failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>

      {/* ── Price display ── */}
      <div style={{ textAlign:"center", marginBottom:28 }}>
        <ModalPriceDisplay usdDisplay={usdDisplay} localDisplay={localDisplay} dark={false} />
      </div>

      {/* ── User info summary ── */}
      <div style={{ background:"#f8fafc", borderRadius:12, padding:"12px 16px", marginBottom:20, display:"flex", alignItems:"center", gap:10 }}>
        <div style={{ width:36, height:36, borderRadius:"50%", background:"linear-gradient(135deg,#2563eb,#1d4ed8)", color:"#fff", fontWeight:700, fontSize:14, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
          {(userName || userEmail || "?")[0].toUpperCase()}
        </div>
        <div style={{ flex:1, minWidth:0 }}>
          {userName && <div style={{ fontSize:13, fontWeight:600, color:"#0f172a", marginBottom:1 }}>{userName}</div>}
          <div style={{ fontSize:12, color:"#64748b", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{userEmail}</div>
        </div>
      </div>

      {/* ── Card input ── */}
      <div style={{ marginBottom:16 }}>
        <label style={{ display:"block", fontSize:12, fontWeight:600, color:"#374151", marginBottom:8, textTransform:"uppercase", letterSpacing:"0.05em" }}>
          Card Details
        </label>
        <div style={{
          border:       `1.5px solid ${cardReady ? "#86efac" : "#e2e8f0"}`,
          borderRadius: 12,
          padding:      "14px 16px",
          background:   "#fff",
          transition:   "border-color 0.2s",
        }}>
          <CardElement
            options={CARD_ELEMENT_OPTIONS}
            onChange={e => { setCardReady(e.complete); if (e.error) setError(e.error.message); else setError(""); }}
          />
        </div>
        <div style={{ fontSize:11, color:"#94a3b8", marginTop:6, display:"flex", alignItems:"center", gap:4 }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
          Secured by Stripe — we never see your card details
        </div>
      </div>

      {/* ── Error ── */}
      {error && (
        <div style={{ background:"#fef2f2", border:"1px solid #fecaca", color:"#dc2626", borderRadius:10, padding:"10px 14px", fontSize:13, marginBottom:16, lineHeight:1.5 }}>
          ⚠️ {error}
        </div>
      )}

      {/* ── Submit button ── */}
      <button
        type="submit"
        disabled={loading || !stripe || !cardReady}
        style={{
          width:        "100%",
          padding:      "14px",
          background:   loading || !cardReady ? "#e2e8f0" : "linear-gradient(135deg,#2563eb,#1d4ed8)",
          color:        loading || !cardReady ? "#94a3b8" : "#fff",
          border:       "none",
          borderRadius: 12,
          fontWeight:   700,
          fontSize:     15,
          cursor:       loading || !cardReady ? "not-allowed" : "pointer",
          transition:   "all 0.2s",
          display:      "flex",
          alignItems:   "center",
          justifyContent: "center",
          gap:          8,
        }}
      >
        {loading ? (
          <>
            <div style={{ width:16, height:16, borderRadius:"50%", border:"2px solid rgba(255,255,255,0.3)", borderTopColor:"#fff", animation:"spin 0.7s linear infinite" }} />
            Processing...
          </>
        ) : (
          <>Pay {usdDisplay} →</>
        )}
      </button>

      {/* ── Local currency note ── */}
      <StripeLocalNote usdDisplay={usdDisplay} localDisplay={localDisplay} />

      {/* ── Trust badges ── */}
      <div style={{ display:"flex", justifyContent:"center", gap:16, marginTop:16, flexWrap:"wrap" }}>
        {[
          { icon:"🔒", text:"SSL secured" },
          { icon:"💳", text:"Stripe payments" },
          { icon:"✅", text:"Instant access" },
        ].map(b => (
          <div key={b.text} style={{ display:"flex", alignItems:"center", gap:5, fontSize:11, color:"#94a3b8" }}>
            <span>{b.icon}</span>{b.text}
          </div>
        ))}
      </div>

    </form>
  );
}

// ─────────────────────────────────────────────
// PLAN INFO — what's included summary
// ─────────────────────────────────────────────
function PlanSummary({ planId }) {
  const plans = {
    ats_basic: {
      name:     "ATS Basic",
      color:    "#2563eb",
      features: [
        "3 ATS analyses",
        "Full ATS Score (0–100)",
        "Keyword gap analysis",
        "AI rewrite suggestions",
        "1 AI-improved resume",
        "1 resume from scratch — free",
        "1 AI cover letter — free",
        "PDF + Word + HTML download",
      ],
    },
    doc_pro: {
      name:     "Document Pro",
      color:    "#7c3aed",
      features: [
        "AI document summary",
        "Visual charts & insights",
        "Document chat / Q&A",
        "3 ATS analyses",
        "1 AI-improved resume",
      ],
    },
  };

  const plan = plans[planId] || plans.ats_basic;

  return (
    <div style={{ marginBottom:24 }}>
      <div style={{ fontSize:13, fontWeight:700, color:"#374151", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:12 }}>
        What's included
      </div>
      <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
        {plan.features.map(f => (
          <div key={f} style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, color:"#374151" }}>
            <div style={{ width:18, height:18, borderRadius:"50%", background:`${plan.color}15`, border:`1px solid ${plan.color}30`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={plan.color} strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            {f}
          </div>
        ))}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// MAIN MODAL
// ─────────────────────────────────────────────
export default function PaymentModal({ onSuccess, onClose, userEmail, userName, planId = "ats_basic", userId }) {

  // Close on backdrop click
  function handleBackdrop(e) {
    if (e.target === e.currentTarget) onClose();
  }

  return (
    <div
      onClick={handleBackdrop}
      style={{
        position:        "fixed",
        inset:           0,
        zIndex:          2000,
        background:      "rgba(15,23,42,0.7)",
        backdropFilter:  "blur(6px)",
        display:         "flex",
        alignItems:      "center",
        justifyContent:  "center",
        padding:         16,
        overflowY:       "auto",
      }}
    >
      <div style={{
        background:   "#fff",
        borderRadius: 20,
        width:        "100%",
        maxWidth:     460,
        boxShadow:    "0 24px 64px rgba(0,0,0,0.3)",
        animation:    "modalIn 0.25s ease",
        overflow:     "hidden",
        margin:       "auto",
      }}>

        {/* ── Header ── */}
        <div style={{ padding:"20px 24px 16px", borderBottom:"1px solid #f1f5f9", display:"flex", alignItems:"center", justifyContent:"space-between", background:"linear-gradient(135deg,#f8faff,#f0f7ff)" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ width:36, height:36, background:"linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"center" }}>
              <span style={{ color:"#fff", fontWeight:800, fontSize:17 }}>R</span>
            </div>
            <div>
              <div style={{ fontWeight:700, fontSize:15, color:"#0f172a" }}>ResumeScoreAI</div>
              <div style={{ fontSize:11, color:"#64748b" }}>Secure checkout</div>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{ background:"none", border:"1px solid #e2e8f0", borderRadius:8, width:32, height:32, cursor:"pointer", fontSize:16, color:"#64748b", display:"flex", alignItems:"center", justifyContent:"center" }}
          >×</button>
        </div>

        {/* ── Body ── */}
        <div style={{ padding:"24px" }}>
          <PlanSummary planId={planId} />

          <Elements stripe={stripePromise}>
            <CheckoutForm
              planId={planId}
              userEmail={userEmail}
              userName={userName}
              userId={userId}
              onSuccess={onSuccess}
              onClose={onClose}
            />
          </Elements>
        </div>

      </div>

      <style>{`
        @keyframes modalIn {
          from { opacity:0; transform:scale(0.95) translateY(10px); }
          to   { opacity:1; transform:scale(1) translateY(0); }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

